import React from 'react';
import { useSelector } from 'react-redux';
var LoggedInCookies = function LoggedInCookies() {
  var loggedIn = useSelector(function (_ref) {
    var user = _ref.user;
    return user.loggedIn;
  });
  var firstName = useSelector(function (_ref2) {
    var user = _ref2.user;
    return user.firstName;
  });
  var lastName = useSelector(function (_ref3) {
    var user = _ref3.user;
    return user.lastName;
  });
  var firstNameParameter = "firstname=".concat(encodeURIComponent(firstName));
  var lastNameParameter = "lastname=".concat(encodeURIComponent(lastName));
  var expirationParameter = "expiration=2592000";
  var queryString = "?".concat(firstNameParameter, "&").concat(lastNameParameter, "&").concat(expirationParameter);
  var url = loggedIn ? "https://www.aje.cn/cookie/login.html".concat(queryString) : "https://www.aje.cn/cookie/logout.html";
  return /*#__PURE__*/React.createElement("iframe", {
    title: "login cookies",
    className: "d-none",
    src: url
  });
};
export default LoggedInCookies;